import apiClient from '../apiClient';

export const getEscuelas = (params = {}) => {
  return apiClient.get('escuelas', { params });
};

// Nueva función para obtener escuelas por localidad (ruta pública)
export const getEscuelasByLocalidad = (localidadId) => {
  return apiClient.get(`escuelas/localidad/${localidadId}`);
};
